<template>
  <header>
    <div class="e-flex nav_box mg-auto text-center jc-around container"  style="width:1900px;">
      <div class="e-flex">
      <div class="nav_box--img" style="margin-top: 12px;">
        <el-button
          v-if="isZCMOrigin"
          type="primary"
          size="mini"
          plain
          @click="handleBackZCMHome"
        >返回交易首页</el-button
        >
        <img :src="logo" alt="" @click="() => $router.push('/')" />

      </div>
        <div
          v-for="(imgItem, index) in NavList"
          :key="index"
          class="nav_box--item"
        >
          <el-dropdown
            v-if="imgItem.Item"
            trigger="click"
            @command="dropDownItemClick"
          >
            <span class="el-dropdown-link mouse_hover" :style="imgItem.style">
              {{ imgItem.text }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              style="width: 180px; text-align: center"
            >
              <el-dropdown-item
                :tabindex="index"
                :command="Item"
                v-for="(Item, index) in imgItem.Item"
                :key="index"
              >
                {{ Item.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a
            v-else
            class="el-dropdown mouse_hover"
            :style="imgItem.style"
            @click="dropDownItemClick(imgItem)"
          >{{ imgItem.text }}</a
          >
        </div>
        <!-- 生产环境隐藏啄木鸟logo-->
        <div v-if="!isHlj && !isBsgzw" class="zmn" @click="toZmn">
          <img src="../../assets/zmning/bander2.png" alt="">
        </div>
        <div @click="LoginClick" class="ml-5 userBox nav_box--item">
          <el-button
            type="primary"
            style="width: 120px"
            @click="handleLogin"
            v-if="!name"
          >
            {{ loginStatus }}</el-button
          >
          <el-dropdown
            v-if="name"
            @command="handleCommand"
            trigger="click"
            class="userInfos"
          >
            <span class="el-dropdown-link">
              {{ name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="order" icon = "el-icon-document">我的订单</el-dropdown-item>
              <el-dropdown-item command="personalInfo" icon = "el-icon-user"
              >我的资料</el-dropdown-item
              >
              <el-dropdown-item command="invoices" icon = "el-icon-postcard">开票信息</el-dropdown-item>
              <!-- <el-dropdown-item command="integral" icon = "el-icon-present">我的积分</el-dropdown-item> -->
              <el-dropdown-item command="outLogin" icon = "el-icon-switch-button">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <login ref="login"></login>
  </header>
</template>

<script>
import Login from '@/common/login'
import { mapGetters, mapState, CONFIG_GETTERS } from '@/store/modules/config'
import { to } from '@/shared/location'
import { remove, cloneDeep } from 'lodash'
import ZCM_LOGO from '@/assets/zcm_logo.png'
import CQSW_LOGO from '@/assets/cqsw.png'
import LOGO from '@/assets/logo@3x.png'
import { shopLogin } from '@/api/user'
import { queryBaseConfig } from '@/api/comm'
import VipJumpUtil from '@/util/vipJumpUtil';

const headerList = [
  {
    text: '首页',
    style: 'font-size: 15px',
    path: '/',
    key: 'home',
  },
  {
    text: '商票贴现（线上贷款）',
    style: 'font-weight: bold;',
    path: '/zcm',
    key: 'zcm',
  },
  // {
  //   text: '安徽移动保函专区',
  //   /**style: 'font-size: 17px; font-weight: bold;',*/
  //   key: 'anhui',
  //   Item: [
  //     {
  //       text: '电子-银行投标保函',
  //       path: '/anhui/bank',
  //     },
  //   ],
  // },
  //   {
  //   text: '贵州银行保函专区',
  //   // style: 'font-size: 17px; font-weight: bold;',
  //   key: 'guizhouBank',
  //   Item: [
  //     {
  //       text: '电子-银行投标保函',
  //       path: '/guizhouBank/bank',
  //     },
  //   ],
  // },
  {
    text: '保函申请',
    key: 'guarantee',
    Item: [
      {
        text: '电子担保保函',
        path: '/guaranteeBankView',
      },
      {
        text: '银行保函',
        path: '/applyBankMain',
      },
      {
        text: '保险保函',
        path: '/applyInsurance',
      },
      {
        text: '履约保函',
        path: '/applicationPerformance',
      },
      // {
      //   text: '预付款保函',
      //   path: '',
      // },
      // {
      //   text: '质量保函',
      //   path: '',
      // },
      // {
      //   text: '农名工工资保函',
      //   path: '',
      // },
      // {
      //   text: '信用报告',
      //   path: '',
      // },
    ],
  },
  {
    text: '保函验真',
    path: '/verify',
    key: 'verify',
  },
  // {
  //   text: '增值服务',
  //   Item: [
  //     {
  //       text: '标书啄木鸟',
  //       path: '',
  //     },
  //   ],
  // },
  // {
  //   text: '关于我们',
  //   path: '/aboutUs',
  //   key: 'about',
  // },
  {
    text: '我的订单',
    path: '/orderListIndex',
    key: 'about',
  },
  //   {
  //   text: '我的积分',
  //   path: '',
  //   key: 'integral',
  // },
]

export default {
  name: 'Header',
  components: {
    Login,
  },
  data() {
    return {
      isCQSW: '',
      applyType: '',
      loginDown: [
        {
          text: '我的订单',
        },
        {
          text: '开票信息',
        },
        {
          text: '退出登录',
        },
      ],
      loginStatus: '立即登录', // mapGetter Staus
      imgItemChangeText: '电子保函',
    }
  },
  computed: {
    isHlj() {
      return this.$store.state.letter.isHlj
    },
    cqswCodeFn() {
      return this.$store.state.letter.isCqsw
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
    ...mapState({
      state: 'config',
    }),
    ...mapGetters({
      isZCMOrigin: CONFIG_GETTERS.IS_ZCM_ORIGIN,
    }),
    NavList() {
    let list = cloneDeep(headerList);
    if (this.isCQSW) {
      list = remove(list, (item) => item.key !== 'anhui' && item.key !== 'zcm');
    }  else {
      const removeKey = this.isZCMOrigin ? 'anhui' : 'zcm';
      list = remove(list, (item) => item.key !== removeKey);
    }
    if (this.isCQSW) {
      list = list.filter(item => item.key !== 'guarantee');
    }
    if (this.isHlj) {
      list = remove(list, (item) => item.key !== 'guarantee');
    }
    return list;
  },
    logo() {
      if (this.isBsgzw) return this.$cdn.logo.bsgzw_logo
      return this.isZCMOrigin ? ZCM_LOGO : this.isCQSW ? CQSW_LOGO : LOGO
    },
    UserInfo() {
      return this.$store.getters.userInfo || null
    },
    name() {
      return this.$store.getters.name || null
    },
  },
  created() {
    this.getInfo()
    this.$on('openLogin', () => {
      this.handleLogin()
    })
    queryBaseConfig({key:'vip_cleaning_tool_url'}).then((v) => {
      localStorage.setItem('vipUrl', v.data);
    })
  },
  watch: {
    cqswCodeFn: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal === true) {
          this.isCQSW = true
        } else {
          this.isCQSW = false
        }
      },
      // 立即处理 进入页面就触发
      immediate: true,
      // 深度监听 属性的变化
      deep: true
    },
  },
  methods: {
    handleBackZCMHome() {
      to('http://toubiao.zcmmall.com/', '_self')
    },
    // 打开登录框
    handleLogin() {
      this.$refs.login.open()
    },
    handleCommand(command) {
      if (command === 'outLogin') {
        this.logout()
      } else if (command === 'order') {
        this.$router.push('/orderListIndex')
      } else if (command === 'personalInfo') {
        this.$router.push('/personalInfo')
      } else if (command === 'invoices') {
        this.$router.push('/invoiceIndex')
      } else if (command === 'integral') {
        shopLogin().then(res => {
          if (res.data.isLogin === '0') {
            this.handleLogin()
          } else {
            window.open(res.data.url)
          }
        })
      }
    },
    logout() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store
            .dispatch('user/logout')
            .then(() => {
              this.$router.push('/')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // login or regist dropdown for Item
    LoginClick() {
      // ... if loginStatus
    },
    // dropdown Change
    dropDownItemClick(menu) {
      if(menu && menu.key === 'integral'){
       shopLogin().then(res => {
          if (res.data.isLogin === '0') {
            this.handleLogin()
          } else {
            window.open(res.data.url)
          }
        })
        return
      }else if (!(menu && menu.path)) {
        this.$message.warning('该功能正在开发中。。。')
        return
      }
      this.$router.push({
        path: menu.path,
      })
    },
    getInfo() {
      const { token } = this.$store.getters
      if (token) {
        this.$store
          .dispatch('user/getInfo')
          .then(() => {})
          .catch(() => {})
      }
    },
    toZmn() {
      VipJumpUtil.jumpToVip(this)
      // this.$router.push(
      //   {
      //     path: '/bidWoodpecker',
      //     // query:{

      //     // }
      //   }
      // )
    },
},
}
</script>

<style scoped lang="less">
header {
  display: flex;
  height: 70px;
  border-bottom: 1px solid #eee;
  z-index: 2;
  position: relative;
}
.el-popper .popper__arrow {
  border-bottom-color: #1ebef4 !important;
  left: 50% !important;
  visibility: hidden;
}
.nav_box {
  align-items: center;
  background: #ffffff;
  overflow-x: auto;
  &--img {
    display: flex;
    align-items: center;
    height: 40px;
    /deep/ .el-button {
      margin-right: 40px;
    }
    img {
      height: 100%;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  &--item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 20px;
  }
}
.el-dropdown {
  color: #333;
}
.userBox {
  cursor: pointer;
}
.zmn{
  width: 204px;
  height: 50px;
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
